import isNextActive from '../../../packages/is-next-active';

export const useNextRCE = isNextActive;
